/**
 * @fileoverview GET handler for the "/engagement/segments/workflows_for_link_segmentation" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementSegmentsWorkflowsForLinkSegmentation } from "./constants";
import type { EngagementSegmentsWorkflowsForLinkSegmentationResult } from "./types";

export const getEngagementSegmentsWorkflowsForLinkSegmentation = reactQueryFetcherAdapter(
  engagementSegmentsWorkflowsForLinkSegmentation,
  (
    signal: AbortSignal,
    appGroupId: string,
    query: string,
    limit: number
  ): Promise<EngagementSegmentsWorkflowsForLinkSegmentationResult[]> => {
    return fetch(
      "/engagement/segments/workflows_for_link_segmentation",
      "GET",
      { app_group_id: appGroupId, query, limit },
      { signal }
    );
  }
);
